import Checkbox from 'components/Form/Checkbox';
import Field from 'components/Form/Field';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import SectionHeader from 'components/SectionHeader';
import {H2} from 'components/Typography';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiErrorAxios} from 'utils/request-axios/utils';

import {labelWidth} from '../styles.module.css';
import useDXSettings from './services';
import {BackendData, FormData} from './types';

const DXNoticeSettings = () => {
    return (
        <Field label={t`Disable Email Collection Feature`} type="checkbox">
            <Checkbox name="notRequireDx" />
        </Field>
    );
};

const Page = () => {
    const {data} = useBackend<BackendData>();
    const methods = useForm<FormData>({
        defaultValues: {
            notRequireDx: data.notRequireDx,
        },
    });
    const disableSubmit = methods.formState.isSubmitting;
    const editDXSettings = useDXSettings();

    const onSubmit = async (formData: FormData) => {
        await editDXSettings
            .mutateAsync({clientMid: data.clientMid, formData})
            .then(() => {
                setUrl(`/home/client/${data.clientMid}/securesend/`);
            })
            .catch(onApiErrorAxios(methods));
    };

    return (
        <FormProvider {...methods}>
            <header className="flex flex-col">
                <div className="flex items-start justify-between">
                    <H2>{data.clientName}</H2>
                </div>
            </header>
            <SectionHeader
                subtitle={t`The following are applied to Email Address Collection for this Client.`}
                title={t`Email Address Collection`}
            />
            <div className="w-[612px]">
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <SideBySide className={twMerge('mt-5', labelWidth)}>
                        <DXNoticeSettings />
                        <FormResult />
                        <FormActions align="left">
                            <SubmitButton
                                disabled={disableSubmit}
                            >{t`Save`}</SubmitButton>
                        </FormActions>
                    </SideBySide>
                </form>
            </div>
        </FormProvider>
    );
};
export default Page;
